// @flow

import React, { Component } from 'react';
import '../../src/App.css';
import _QuestionHandler from './questions/_QuestionHandler';

type Props = {
  question?: string,
  onClick?: () => void,
  checked: boolean
};

type State = {
  checked: boolean
};

class BoxCheck extends Component<Props, State> {
  render() {
    const { checked } = this.props;
    return (
      <div onClick={this.props.onClick} className="box">
        <p>{this.props.question}</p>
        {/* <input
          checked={this.props.checked}
          value={this.props.checked}
          type="checkbox"
          defaultChecked={false}
        /> */}
        {this.props.checked ? (
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 62 62"
            version="1.1"
            // xmlns="http://www.w3.org/2000/svg"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <desc>Created with Sketch.</desc>
            <defs />
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g id="Group">
                <rect
                  id="Rectangle-2-Copy"
                  fill="#70AC4B"
                  x="0"
                  y="0"
                  width="62"
                  height="62"
                  rx="8"
                />
                <polyline
                  id="Path-2"
                  stroke="#FFFFFF"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="16.1238303 34.3525585 26.3609634 45.5875711 51.2723347 18.2479273"
                />
              </g>
            </g>
          </svg>
        ) : (
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 62 62"
            version="1.1"
            // xmlns="http://www.w3.org/2000/svg"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <defs />
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <rect
                id="Rectangle-2"
                stroke="#4E4E4E"
                strokeWidth="5"
                x="2.5"
                y="2.5"
                width="57"
                height="57"
                rx="8"
              />
            </g>
          </svg>
        )}
      </div>
    );
  }
}

export default BoxCheck;



// WEBPACK FOOTER //
// ./src/components/BoxCheck.js